export default __webpack_public_path__ + "static/media/visual3.5126f1ae.png";